import Vue from 'vue';
import Vuex from 'vuex';
import sound from './modules/sound';
import user from './modules/user';
import socket from './modules/socket';
import notice from './modules/notice';
import userInfo from './modules/userInfo';
import accountList from './modules/accountList';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    sound,
    user,
    socket,
    notice,
    userInfo,
    accountList,
  },
  plugins: [
    createPersistedState({
      key: 'chat-web-store',
      paths: ['user', 'sound'],
      storage: window.localStorage,
      reducer: (state) => ({
        user: state.user,
        sound: {
          muted: state.sound.muted,
          newMessageMuted: state.sound.newMessageMuted,
          likeMessageMuted: state.sound.likeMessageMuted,
        },
      }),
    }),
  ],
});
